export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const GET_USER_INFO_SUCCESS = 'GET_USER_INFO_SUCCESS'

export const GET_MY_COMPANY_SUCCESS = 'GET_MY_COMPANY_SUCCESS'
export const GET_MY_COMPANY_PRODUCTS_SUCCESS = 'GET_MY_COMPANY_PRODUCTS_SUCCESS'
export const CLEAR_COMPANY_REDUX = 'CLEAR_COMPANY_REDUX'

export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS'

export const GET_CITIES_SUCCESS = 'GET_CITIES_SUCCESS'

export const GET_CONVERSATIONS_SUCCESS = 'GET_CONVERSATIONS_SUCCESS'
export const CLEAR_CONVERSATIONS_REDUX = 'CLEAR_CONVERSATIONS_REDUX'

export const SAVE_VISITED_COMPANY = 'SAVE_VISITED_COMPANY'
export const DELETE_VISITED_COMPANIES = 'DELETE_VISITED_COMPANIES'

export const GET_HOME_PAGE_COMPANIES = 'GET_HOME_PAGE_COMPANIES'
export const GET_HOME_PAGE_COMPANIES_SUCCESS = 'GET_HOME_PAGE_COMPANIES_SUCCESS'
